import { Button, Stack, Typography } from '@mui/material';

type ToastContentComponentProps = {
  content: string;
  handleView: () => void;
  dataTestId: string;
};

export const ToastContentComponent = (props: ToastContentComponentProps) => {
  const { content, handleView, dataTestId } = props;

  return (
    <Stack
      spacing={1}
      data-testid={dataTestId}
    >
      <Typography sx={{ whiteSpace: 'pre-line' }}>{`${content}...`}</Typography>
      <Button
        onClick={handleView}
        size="small"
        data-testid="viewButton"
      >
        Просмотреть
      </Button>
    </Stack>
  );
};
